export const borderSize = {
  xsmall: '0.0625rem', // 1px
  small: '0.125rem', // 2px
  medium: '0.375rem', // 6px
  large: '0.75rem', // 12px
  xlarge: '1.5rem', // 24px
};

export default borderSize;
